export const sortingTypes = {
  rate: 'rate',
  bank: 'bank',
  country: 'country',
  term: 'term',
  noticePeriod: 'noticePeriod',
};

export const sortingDirections = {
  desc: 'desc',
  asc: 'asc',
};

export const countryCreditRatingsType = {
  BEST: 'BEST',
  VERY_GOOD_AND_HIGHER: 'VERY_GOOD_AND_HIGHER',
  GOOD_AND_HIGHER: 'GOOD_AND_HIGHER',
  ACCEPTABLE_AND_HIGHER: 'ACCEPTABLE_AND_HIGHER',
};

export default {
  defaultRate: 'nominal_interest_rate',
  investNowButtonText: null,
  loadingPlaceholders: 10,
  enviromentCurrency: 'EUR',
  environment: 'EUR',
  showEasyAccessLabel: false,

  url: {
    base: '',
  },

  features: {
    showFilterComponent: true,
    showTermFilter: true,
    showCountryCreditRatingFilter: false,
    showFlexgeldFilter: false,
    showForeignCurrencyFilter: false,
    showProductDetails: true, // TODO this should be renamed to showTabs.
    showChip: false,
    showRibbon: false,
    showBankInfo: false,
    showRiskBanner: false,
    showInvestmentAmountFilter: false,
    showDepositProtection: false,
    showVariableInterestLabel: false,
    showBankTab: false,
    showDepositGuaranteeTab: false,
    showCountryCreditRating: false,
    splitNoticeAccountFromOvernightOffers: false,
    showFullOnlineProcessChip: false,
    showFlexgeldChip: false,
    showFinanztestBestenListeChip: false,
    showNoWithholdingTaxChip: false,
    showAlternativeRateDecreaseTooltipForOvernight: false,
    showSpecialNoticeAccountAsOvernight: true,
    showCTAButtons: true,
    offerDetails: {
      showCompounding: false,
      showInterestBooking: false,
      showInterestBookingOnlyForOvernight: false,
      showInterestTaxation: true,
      showInterestType: false,
      showInterestPayout: true,
      showInterestEarlyTermination: true,
      showInterestPayment: false,
      showInterestTypeInAER: false,
      showImportantInformation: false,
      showRepresentativeExample: false,
      showSpecialFeatures: false,
      showCosts: false,
      showWithholdingTax: true,
      showAdditionalDocuments: false,
      showCurrency: true,
      showEffectiveInterestRate: true,
      prolongation: {
        show: false,
        hideForOvernight: false,
      },
      showProductInformationPDFLink: true,
    },
    showInterestEarned: false,
    showDecimalPlacesForInterestAndBonus: false,
    showBonus: false,
    showDepositGuaranteeHeading: true,
  },

  filter: {
    currency: 'EUR',
    showOnlyFlexgeld: false,
    showForeignCurrency: false,
    term: { min: 0, max: 120 },
    type: null,
    limit: 10,
    offset: 0,
    increaseLimitBy: 50,
    investmentAmount: 50000,
    countryCreditRating: countryCreditRatingsType.ACCEPTABLE_AND_HIGHER,
    banksToExclude: [],
    termsToInclude: [],
    ratingsToInclude: [],
    countriesToShow: [],
    showOnlyFinanztestBestenlisteProducts: false,
  },

  order: {
    direction: sortingDirections.desc,
    byKey: sortingTypes.rate,
  },
};

export const productTypes = {
  TERM_DEPOSIT: 'term_deposit',
  OVERNIGHT_DEPOSIT: 'overnight_deposit',
  FLEXGELD: 'flexgeld',
  FORREIGN_CURRENCY: 'foreign_currency',
  NOTICE_ACCOUNT: 'notice_account',
};

// The list represents S&P ratings ordered from highest to lowest.
export const countryCreditRatings = [
  'AAA',
  'AA+',
  'AA',
  'AA-',
  'A+',
  'A',
  'A-',
  'BBB+',
  'BBB',
  'BBB-',
  'BB+',
  'BB',
  'BB-',
  'B+',
  'B',
  'B-',
  'CCC+',
  'CCC',
  'CCC-',
  'CC',
  'SD',
  'D',
  'NR',
];

// We don't have offers whose rating is bellow 'B' in our platform intentionally
export const countryCreditRatingsRange = {
  BEST: countryCreditRatings.indexOf('AA-'),
  VERY_GOOD_AND_HIGHER: countryCreditRatings.indexOf('A-'),
  GOOD_AND_HIGHER: countryCreditRatings.indexOf('BBB-'),
  ACCEPTABLE_AND_HIGHER: countryCreditRatings.indexOf('B'),
};
